import { render, staticRenderFns } from "./FlexiquoteModuleView.vue?vue&type=template&id=261be19a&scoped=true"
import script from "./FlexiquoteModuleView.vue?vue&type=script&lang=js"
export * from "./FlexiquoteModuleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261be19a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('261be19a')) {
      api.createRecord('261be19a', component.options)
    } else {
      api.reload('261be19a', component.options)
    }
    module.hot.accept("./FlexiquoteModuleView.vue?vue&type=template&id=261be19a&scoped=true", function () {
      api.rerender('261be19a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/superadmin/flexiquotemodule/FlexiquoteModuleView.vue"
export default component.exports